var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutorial"},[_c('GameStage',{attrs:{"stage":_vm.stage,"componentTypes":_vm.componentTypes,"fillTiles":false}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.nextTooltipExists)?_c('ArrowButton',{attrs:{"action":_vm.skip,"direction":'right'}},[_vm._v(_vm._s(_vm.skipText))]):_vm._e()],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d526ad24","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Tutorial.vue
// module id = null
// module chunks = 